/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
export function useTooltipControllerSharedState() {
  const state = React.useMemo(() => ({
    ignoreNonTouchEvents: false,
    timers: {
      enter: null,
      leave: null,
      touch: null
    }
  }), []);
  React.useEffect(() => {
    return () => {
      window.clearTimeout(state.timers.enter);
      window.clearTimeout(state.timers.leave);
      window.clearTimeout(state.timers.touch);
    };
  }, [state]);
  return state;
}